module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "ident dedicaces",
    attrs: {
      "epub:type": "dedication",
      "id": "dedicaces",
      "role": "doc-dedication"
    }
  }, [_c('p', {
    staticClass: "dedi"
  }, [_c('span', [_vm._v("To Kathryn Helmers, my agent, who kept asking,"), _c('br'), _vm._v("\n    “What if?” until if came true.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90ea157c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ident13.vue
// module id = 63
// module chunks = 0